module.exports = __webpack_public_path__ + "static/03-258e99a8de9fe721a2223aa9c93ea881.jpg";